import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Button} from 'views/components';

import {Translate} from 'views/module';

import {AddCircleOutline as AddCircleOutlineIcon} from 'views/icons';

import AddNewContact from './AddNewContact';
import ClientLeadContact from './ClientLeadContact';

const ClientLeadContacts = (props) => {
  const [isAdding, setIsAdding] = React.useState(false);

  const {
    clientLeadData,
    clientLeadBackend,
  } = props;

  const contacts = Object.values(clientLeadData.contacts);

  return (
    <>
      <Stack
        spacing={2}
        sx={{
          pb: 2,
        }}
      >
        {
          contacts.map((contact, index) => {
            return (
              <ClientLeadContact
                key={index}
                contact={contact}
                clientLeadData={clientLeadData}
                clientLeadBackend={clientLeadBackend}
              />
            );
          })
        }
        <Button
          startIcon={<AddCircleOutlineIcon />}
          onClick={() => setIsAdding(true)}
        >
          <Translate expression='clientLead.ClientLeadDetail.Settings.Contact.CreateNew.Action' />
        </Button>
        {
          isAdding &&
          <AddNewContact
            clientLeadData={clientLeadData}
            clientLeadBackend={clientLeadBackend}
            isEditing={isAdding}
            setIsEditing={setIsAdding}
          />
        }
      </Stack>
    </>
  );
};

ClientLeadContacts.propTypes = {
  clientLeadData: PropTypes.object.isRequired,
  clientLeadBackend: PropTypes.object.isRequired,
};

export default React.memo(ClientLeadContacts);
